var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dinamic-viewer"},_vm._l((_vm.items),function(item){return _c(item,{key:item.name,ref:"itemRefs",refInFor:true,tag:"component"})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }